import { create } from 'zustand';

export type ModalType = 'email';

interface ModalData {
    documentId?: string;
    hasPdf?: boolean;
}

export interface ModalStore {
    type: ModalType | null;
    data: ModalData;
    onClose: () => void;
    isOpen: boolean;
    onOpen: (type: ModalType, data?: ModalData) => void;
}

export const useModal = create<ModalStore>((set) => ({
    data: {},
    type: null,
    isOpen: false,
    onOpen: (type, data = {}) => set({ isOpen: true, type, data }),
    onClose: () => set({ isOpen: false, type: null }),
}));
